module.exports = __webpack_public_path__ + "static/media/on.2b736fb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/on.svg
// module id = 1584
// module chunks = 0